export const MAIN_DASHBOARD_TAB_KEY = "mainDashboardTab";
export const ITS_ONE_VIEW_LAST_ITS_KEY = "itsOneViewLastIts";

export type MainDashboardTab = "modules" | "itsOneView";

export function readMainDashboardTab(): MainDashboardTab {
  if (typeof window === "undefined") return "modules";
  const stored = sessionStorage.getItem(MAIN_DASHBOARD_TAB_KEY);
  return stored === "itsOneView" ? "itsOneView" : "modules";
}

export function writeMainDashboardTab(tab: MainDashboardTab): void {
  sessionStorage.setItem(MAIN_DASHBOARD_TAB_KEY, tab);
}

export function readItsOneViewLastIts(): string {
  if (typeof window === "undefined") return "";
  return sessionStorage.getItem(ITS_ONE_VIEW_LAST_ITS_KEY) ?? "";
}

export function writeItsOneViewLastIts(itsNo: string): void {
  sessionStorage.setItem(ITS_ONE_VIEW_LAST_ITS_KEY, itsNo);
}
